/**
 * Public API barrel for the pure domain engine (ARCHITECTURE §2, §3).
 *
 * The engine is framework-free (no React, no IO). It is the only surface the
 * `state/` layer imports — downstream code depends on this stable seam, never
 * on internal module paths.
 */
export const ENGINE_NAME = "ledgerline-core" as const;
export const ENGINE_VERSION = "1.0.0" as const;

export * from "./types";
export {
  minorDigits,
  money,
  zero,
  add,
  subtract,
  negate,
  abs,
  isZero,
  isNegative,
  compare,
  allocate,
  scale,
  convert,
  parseAmount,
  format,
  formatWithCurrency,
} from "./money";

export {
  DEFAULT_CHART,
  isDebitNormal,
  indexAccounts,
  accountTypeLabel,
} from "./chartOfAccounts";
export {
  checkBalance,
  validateEntry,
  sumDebits,
  sumCredits,
  type BalanceCheck,
  type ValidationResult,
} from "./journal";
export {
  buildLedger,
  accountBalance,
  sumByTypes,
  type AccountBalance,
} from "./ledger";
export {
  trialBalance,
  type TrialBalance,
  type TrialBalanceRow,
} from "./trialBalance";
export {
  incomeStatement,
  balanceSheet,
  type IncomeStatement,
  type BalanceSheet,
  type StatementLine,
} from "./statements";
export {
  rateFor,
  vatOnNet,
  splitGross,
  vatSummary,
  VAT_CONTROL,
  type VatSummary,
} from "./vat";
export {
  estimateCt,
  ctCategoryLabel,
  type CtInputs,
  type CtEstimate,
} from "./corporateTax";
export { rateOf, toBase, revalue, FX_GAIN_LOSS, type Revaluation } from "./fx";
export {
  consolidate,
  type ConsolidationView,
  type UnmatchedItem,
} from "./consolidation";
export {
  bankMovements,
  reconcile,
  type BankTxn,
  type BookMovement,
  type Match,
  type Reconciliation,
  type ReconcileOptions,
} from "./reconcile";
